export const DASHBOARD_URLS = {
  localhost: "http://localhost:3000",
  testbooking: "https://test-app.heyhomero.com",
  booking: "https://dashboard.heyhomero.com",
  beta: "https://beta-app.heyhomero.com",
};
